import React from "react";
import { Navigate, useLocation } from "react-router-dom";

interface ProtectedRouteProps {
  children: React.ReactNode;
  allowedFrom: string | string[];
  redirectTo: string;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children, allowedFrom, redirectTo }) => {
  const location = useLocation();
  const state = location.state as { from?: string } | null;

  // Normalize allowedFrom into an array
  const allowedList = Array.isArray(allowedFrom) ? allowedFrom : [allowedFrom];

  if (!state || !allowedList.includes(state.from || "")) {
    return <Navigate to={redirectTo} replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
